import { ICompany } from '@company/company.structures';
import { ICompanySelectorDialog } from '@interfaces';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CompanyService } from '@company/company.service';

interface IOptions {
  id: number;
  name: string;
  selected: boolean;
}
@Component({
  selector: 'app-company-selector',
  templateUrl: './company-selector.component.html',
  styleUrls: ['./company-selector.component.sass']
})
export class CompanySelectorComponent implements OnInit {
  companies: IOptions[];

  constructor(
    public dialogRef: MatDialogRef<CompanySelectorComponent>,
    private companyService: CompanyService,
    @Inject(MAT_DIALOG_DATA) public info: ICompanySelectorDialog
  ) {
    this.companies = [];
    info.companies.map((company: ICompany) => {
      this.companies = [...this.companies, {id: company.id, name: company.name, selected: false}];
    });
  }

  ngOnInit() {
  }

}
